import {HighlightLegend} from './highlight-legend';

export class HighlightDots extends HighlightLegend {
  constructor(name: string, color: string) {
    super(name, color);
    this.type = 'dot';
  }

  public equals(legend: HighlightLegend): boolean {
    return this.name.toLowerCase().trim() === legend.name.toLowerCase().trim();
  }
}
